module.exports = __webpack_public_path__ + "img/gamex.0c03aa7a.png";